
// constants as defined in RevoXef’s App\Models\Config\Business
const ALWAYS = 0
const NEVER = 1
const ASK = 2
const MAIL = 3

export default {
  ALWAYS,
  NEVER,
  ASK,
  MAIL,
}
